import React, { Component } from "react";
import { Menu, Dropdown, Icon, Avatar } from "antd";
import { Link } from "react-router-dom";
import { connect } from '@/models/index';
import { toLogin, getLoginUser } from "@/commons";
import ModifyPassword from "./ModifyPassword";
import config from "@/commons/config-hoc";
import { sxAjax } from "@/commons/ajax";
import "./style.less";

declare var abp: any;
const Item = Menu.Item;

@config({ ajax: true, kepalive: false })
@connect(({ staffing }) => ({ staffing }))
export default class HeaderUser extends Component {
    static defaultProps = {
        theme: "default",
    };

    state = {
        passwordVisible: false,
    };

    handleMenuClick = ({ key }) => {
        if (key === "logout") {
            let num = window.localStorage.getItem('accountLogin');
            if (num == "1") {
                sxAjax.get(`documentinterface/api/Third/GetThirdLogOutPath`).then((response) => {
                    if (response.success) {
                        window.location.href = response.data
                    }
                })
            } else {
                localStorage.clear();
                sessionStorage.clear();
                abp.auth.clearToken();
                var urlList = JSON.parse(abp.setting.values["App.DocumentService.InvoiceCheckMultConfig"]);
                window.location.href = urlList.JMSSOLogoutURL;
            }

            //this.props.ajax.post('/mock/logout').then(toLogin);
            // toLogin();
            // sxAjax.get(`/SolomonService/Logout`)
            //     .then((res) => {
            //登出：调用wof管理平台退出接口
            //洁美登录地址
            // });
        }

        if (key === "modifyPassword") {
            this.setState({ passwordVisible: true });
        }
    };

    componentDidMount = () => {
        const { action } = this.props;
        const user = getLoginUser() || {};
        const id = user.id;
        action.staffing.getUser({ Id: id });
    }

    render() {
        const { className, theme, action, staffing: { user } } = this.props;

        const menu = (
            <Menu
                styleName="menu"
                theme={theme}
                selectedKeys={[]}
                onClick={this.handleMenuClick}
            >
                <Item key="modifyInfo">
                    <Link to={`/personaldata?${Math.random()}`}>
                        {/* <Icon type="lock" /> */}
                        修改信息
                    </Link>
                </Item>
                <Item key="modifyPassword">
                    {/* <Icon type="edit" /> */}
                    修改密码
                </Item>
                {/* <Item><Link to="/settings"><Icon type="setting"/>设置</Link></Item> */}
                {process.env.NODE_ENV === "development" ? (
                    <Item>
                        <Link to="/menu-permission">
                            {/* <Icon type="lock" /> */}
                            菜单
                        </Link>
                    </Item>
                ) : null}
                <Menu.Divider />
                <Item key="logout">
                    {/* <Icon type="logout" /> */}
                    退出登录
                </Item>
            </Menu>
        );
        return (
            <div styleName="user-menu" ref={(node) => (this.userMenu = node)}>
                <Dropdown
                    overlay={menu}
                    getPopupContainer={() => this.userMenu || document.body}
                >
                    <span styleName="account" className={className}>
                        {/* <Icon type="user" /> */}
                        <Avatar
                            style={{
                                backgroundColor: '#F7B000',
                                verticalAlign: 'middle',
                                fontSize: 20
                            }}
                            size="large"
                            gap={4}
                        >
                            {(user.name ?? 'A').substring(0, 1)}
                        </Avatar>
                        <span style={{ fontSize: 14, marginLeft: 10 }}>{user.name || ''}</span>
                        <Icon type="caret-down" />
                    </span>
                </Dropdown>

                <ModifyPassword
                    visible={this.state.passwordVisible}
                    onOk={() => this.setState({ passwordVisible: false })}
                    onCancel={() => this.setState({ passwordVisible: false })}
                />
            </div>
        );
    }
}
